import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: null as TemplateModel | null,
  error: null,
};

const dataSlice = createSlice({
  name: "update-model",
  initialState: initialState,
  reducers: {
    initUpdateModel: () => {
      return { ...initialState };
    },
    startUpdateModel: (state) => {
      state.loading = true;
    },
    successUpdateModel: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpdateModel: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initUpdateModel,
  startUpdateModel,
  successUpdateModel,
  errorUpdateModel,
} = dataSlice.actions;

export default dataSlice.reducer;
